import EJSON from 'ejson';
export class Template {
    constructor(source, fields, sourceFormat) {
        this.source = source;
        this.context = fields;
        this.sourceFormat = sourceFormat !== null && sourceFormat !== void 0 ? sourceFormat : 'text';
    }
    // Convert our type to JSON.
    toJSONValue() {
        return {
            source: this.source,
            sourceFormat: this.sourceFormat,
            context: EJSON.toJSONValue(this.context),
        };
    }
    // Unique type name.
    typeName() {
        return 'Template';
    }
}
//# sourceMappingURL=template.js.map